export default __webpack_public_path__ + "static/media/delete-row.4a8d52c0.svg";